import React from 'react'
import PropTypes from 'prop-types'
import ReactCardFlip from 'react-card-flip'
import CreditCardFrontImage from '@loyal_images/payment/credit-card-front.png'
import CreditCardBackImage from '@loyal_images/payment/credit-card-back.png'

const CardFlip = ({
  isCardCvvEditing,
  cardNumber,
  cardBrand,
  cardHolderName,
  cardExpirationDate,
  cardCvv
}) => (
  <div className='col-12 col-md-6 mt-3 mt-md-0'>
    <div className='row  align-items-center h-100'>
      <div className='col-12 txt-center pos-relative inserted'>
        <div className='image-credit-card front_credit-card'>
          <ReactCardFlip isFlipped={isCardCvvEditing}>
            <div className='front' key='front'>
              <img
                src={CreditCardFrontImage}
                alt={`${process.env.REACT_APP_PAYMENT_COMPLEMENT_TEXT || 'Cartão'}`}
                className='creditcard w-100'
              />
            </div>
            <div className='back' key='back'>
              <img
                src={CreditCardBackImage}
                alt={`${process.env.REACT_APP_PAYMENT_COMPLEMENT_TEXT || 'Cartão'}`}
                className='creditcard w-100'
              />
            </div>
          </ReactCardFlip>
        </div>
        {!isCardCvvEditing ? (
          <div>
            <span className='front_credit-card brand_credit-card txt-body-sm txt-ocr-a-std d-block color-ui-2 txt-uppercase'>
              {cardBrand && (
                <img
                  src={cardBrand.imageUrl}
                  alt={cardBrand.name}
                />
              )}
            </span>
            <span className='front_credit-card brand_credit-card txt-body-sm txt-ocr-a-std d-block color-ui-2 txt-uppercase'>
              <img src='' alt='' />
            </span>
            <span className='front_credit-card number_credit-card txt-body-sm txt-ocr-a-std d-block color-ui-2 txt-uppercase'>
              {cardNumber || '**** **** **** ****'}
            </span>
            <span className='front_credit-card name_credit-card txt-body-sm txt-ocr-a-std d-block color-ui-2 txt-uppercase'>
              {cardHolderName || 'Nome e Sobrenome'}
            </span>
            <span className='front_credit-card date_credit-card txt-body-sm txt-ocr-a-std d-block color-ui-2 txt-uppercase'>
              {cardExpirationDate || '00/00'}
            </span>
          </div>
        ) : (
          <span className='back_credit-card cvv_credit-card txt-body-sm txt-ocr-a-std d-block color-ui-1 txt-uppercase'>
            {(isCardCvvEditing && cardBrand && cardBrand.name === 'AmericanExpress') ? (cardCvv || '****') : (cardCvv || '***')}
          </span>
        )}
      </div>
    </div>
  </div>
)

CardFlip.propTypes = {
  isCardCvvEditing: PropTypes.bool,
  cardCvv: PropTypes.number,
  cardNumber: PropTypes.string,
  cardBrand: PropTypes.number,
  cardHolderName: PropTypes.string,
  cardExpirationDate: PropTypes.string
}

export default CardFlip



// WEBPACK FOOTER //
// ./src/Checkout/PointsPurchase/CardFlip.js